
export default {
  name: "ClaudiaFileDownloader",
  data() {
    return {
      isLoading: false,
      allowRootSelection: false,
      language: "es",
      type: "display",
      options: [],
      value: null,
    };
  },
  async mounted() {
    await this.fetchInstallers();
  },
  methods: {
    async fetchInstallers() {
      this.isLoading = true;
      try {
        const { platforms } = await this.$axios.$get("installers");
        this.options = this.buildTree(platforms);
      } catch {
        this.$feedback.error("generic.error");
      } finally {
        this.isLoading = false;
      }
    },
    buildTree(platforms) {
      return platforms.map((platform) => ({
        id: platform.name,
        label: platform.name,
        children: platform.files.map((file) => ({
          icon: "s2-icon-file-regular",
          id: `${platform.name}|${file.name}`,
          label: file.name,
          actions: [{ id: "download", icon: "mc-download-1", label: "Descargar" }],
        })),
      }));
    },
    async handleTreeAction(event) {
      console.log(event);
      if (event.action !== "download") return;
      const [platformName, fileName] = event.breadcrumb[1].split("|");
      await this.downloadInstaller(platformName, fileName);
    },
    async downloadInstaller(platformName, fileName) {
      await this.$store.dispatch("application/prepareInstallersDownload", [
        { name: platformName, files: [{ name: fileName }] },
      ]);
    },
  },
};
